import { Accordion } from 'flowbite-react';
const LlmsConversationalFAQ: React.FC = () => {
    return (
        <>
            <Accordion>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What is Model Context Protocol (MCP)?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Model Context Protocol, or MCP, is a secure framework that governs how AI models interact with data, tools, and systems in enterprise environments. It ensures all agent actions are authorized, traceable, and compliant by enforcing role-based access, logging, and deterministic handovers between models and connectors.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What is Retrieval-Augmented Generation (RAG), and why is it important?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                           RAG combines retrieval and generation techniques to enable LLMs for enterprise to access the most relevant, up-to-date data from internal sources before generating responses. This ensures factual accuracy, transparency, and domain alignment compared to standard language models.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How do RAG pipelines improve enterprise knowledge management?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                           Production-ready RAG pipelines connect various data repositories and create an intelligent semantic search layer. This allows teams to retrieve relevant information instantly, cutting down research, support, and decision response times by over 50% in most enterprise setups.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What makes enterprise chatbots powered by LLMs better than traditional bots?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Unlike rules-based bots, enterprise chatbots built on LLMs with Retrieval-Augmented Generation understand context, sentiment, and nuance. They use vector database-backed semantic search to generate precise, conversationally natural answers across dynamic knowledge sets.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        Can your Conversational AI & RAG models integrate into existing enterprise systems?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Yes. Our secure integrations and MLOps for enterprise architecture support full interoperability with CRMs, ERPs, knowledge platforms, and ticketing systems through APIs, LangChain connectors, and compliant MCP integration layers.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How do you ensure data privacy and governance with LLMs for enterprise?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            All our Conversational AI deployments follow compliance frameworks like SOC 2, ISO 27001, and GDPR. We host private LLMs, control data access via MCP, and implement secure sandboxing to protect sensitive business information.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                       Do you fine-tune models or use prompt engineering?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Depending on the use case, we apply both. For highly domain-specific workflows, fine-tuning or lightweight methods like LoRA are used for adaptation. For flexible conversational use cases, advanced prompt engineering combined with RAG or MCP-based context management ensures precise performance without retraining.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        What is the typical time to go from POC to production deployment?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            Using our fast POCs and prebuilt components for production-ready RAG pipelines, most enterprise chatbot or voice assistant projects transition to low-risk production in 6-8 weeks, significantly faster than traditional AI rollouts.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
                <Accordion.Panel>
                    <Accordion.Title as="h3" className="accordion-title">
                        How do you secure sensitive documents?
                    </Accordion.Title>
                    <Accordion.Content className="accordion-border">
                        <div className="fs-md mb-0 text-secondary dark:text-[#D7DEE5]">
                            All sensitive data is handled within encrypted, sandboxed environments aligned with a zero-trust architecture. Access controls, anonymization layers, and MCP-governed connectors ensure data never leaves approved enterprise boundaries. Additional audit logs track every retrieval and action for governance and compliance.
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>
            </Accordion>
        </>
    );
};

export default LlmsConversationalFAQ;
